import { render, staticRenderFns } from "./OrderRelated.vue?vue&type=template&id=abb39488"
import script from "./OrderRelated.vue?vue&type=script&lang=js"
export * from "./OrderRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports